import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3114885563/src/next-app/app/(authenticated)/client.tsx");
